import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { TreoDateRangeModule } from 'tsui/@treo';
import { SharedModule } from 'app/shared/shared.module';
import { TreoFindByKeyPipeModule } from 'tsui/@treo';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { NgxMapboxGLModule } from 'ngx-mapbox-gl';
import moment from 'moment';

import { ResearchComponent } from 'app/modules/research/research.component';
import { ResearchFiltersComponent } from 'app/modules/research/filters/filters.component';
import { ResearchListComponent } from 'app/modules/research/list/list.component';
import { ResearchDetailsComponent } from 'app/modules/research/details/details.component';
import { FilterModalComponent } from 'app/modules/research/filter-modal/filter-modal.component';
import { SaveParcelModalComponent } from 'app/modules/research/save-parcel-modal/save-parcel-modal.component';
import { ResearchLayersComponent } from 'app/modules/research/layers/layers.component';
import { researchRoutes } from 'app/modules/research/research.routing';
import { environment } from '@env/environment';
import { MapMarkerInfoComponent } from './@components/map-marker-info/map-marker-info.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FloodMapLegendComponent } from './@components/flood-map-legend/flood-map-legend.component';
import { ParcelTableComponent } from './@components/parcel-table/parcel-table.component';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { ColumnSelectorModule } from 'app/shared/components/column-selector/column-selector.module';
import { MatBadgeModule } from '@angular/material/badge';
import {
  TsBadgeModule,
  TsButtonModule,
  TsDividerComponent,
  TsFilterModule,
  TSIconModule,
  TsPageComponent,
  TsPageHeaderModule,
} from 'tsui';
import { MatSortModule } from '@angular/material/sort';
import { OverlayHelperComponent } from 'app/shared/components/overlay-helper/overlay-helper.component';
import { NgOptimizedImage } from '@angular/common';
import { DealStatusLegendComponent } from './@components/deal-status-legend/deal-status-legend.component';

@NgModule({
  declarations: [
    ResearchComponent,
    ResearchFiltersComponent,
    ResearchListComponent,
    ResearchDetailsComponent,
    ResearchLayersComponent,
    FilterModalComponent,
    MapMarkerInfoComponent,
    ParcelTableComponent,
  ],
  imports: [
    RouterModule.forChild(researchRoutes),
    ScrollingModule,
    FloodMapLegendComponent,
    MatButtonModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatMenuModule,
    MatMomentDateModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatDividerModule,
    DragDropModule,
    TreoFindByKeyPipeModule,
    TreoDateRangeModule,
    SharedModule,
    MatTableModule,
    ColumnSelectorModule,
    MatBadgeModule,
    MatSortModule,
    NgxMapboxGLModule.withConfig({ accessToken: environment.mapbox.accessToken }),
    TsPageHeaderModule,
    TSIconModule,
    TsButtonModule,
    TsBadgeModule,
    TsFilterModule,
    OverlayHelperComponent,
    NgOptimizedImage,
    TsPageComponent,
    DealStatusLegendComponent,
    SaveParcelModalComponent,
    TsDividerComponent,
  ],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: moment.ISO_8601,
        },
        display: {
          dateInput: 'LL',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
  ],
})
export class ResearchModule {}
